import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CheckIcon from "../../../assets/svg/check-icon";
import { setAppearanceMode } from "../../../redux/slices/themeProviderSlice";
import { RootState } from "../../../redux/store";
import LightModeBg from "../../../assets/images/light-mode.png";
import DarkModeBg from "../../../assets/images/dark-mode.png";
import AutoModeBg from "../../../assets/images/auto-mode.png";

const Appearance = () => {
  const dispatch = useDispatch();
  const appearanceMode = useSelector(
    (state: RootState) => state.themeProvider.appearanceMode
  );

  const handleAppearanceChange = (mode: "light" | "dark" | "auto") => {
    dispatch(setAppearanceMode(mode));
  };

  return (
    <div className="flex flex-col gap-[24px] px-[24px] py-[16px]">
      <p className="text-base font-normal text-data dark:text-data-dk">
        Customise your dashboard by changing the appearance
      </p>
      <div className="flex flex-wrap gap-[12px]">
        <button
          className="flex items-start flex-col gap-[8px]"
          onClick={() => handleAppearanceChange("light")}
        >
          <div
            className={`relative w-[125px] h-[82px] rounded-lg flex items-center justify-center overflow-hidden ${
              appearanceMode === "light"
                ? "border-[2px] border-verba-blue"
                : "border-[1px] border-border-gray dark:border-border-gray-dk"
            }`}
          >
            <img
              src={LightModeBg}
              alt="light-mode"
              className="w-full h-full object-cover"
            />
            {appearanceMode === "light" && (
              <div className="absolute inset-0 bg-verba-blue/10" />
            )}
            {appearanceMode === "light" && (
              <div className="absolute bottom-[7px] right-[7px] w-[16px] h-[16px] bg-verba-blue-dark-mode dark:bg-verba-blue-dark-mode-dk rounded-full flex items-center justify-center">
                <CheckIcon className="w-[12px] h-[12px] text-pure-white dark:text-pure-white" />
              </div>
            )}
          </div>
          <p className="text-md font-semibold text-heading-text dark:text-heading-text-dk">
            Light
          </p>
        </button>

        <button
          className="flex flex-col gap-[8px]"
          onClick={() => handleAppearanceChange("dark")}
        >
          <div
            className={`relative w-[125px] h-[82px] rounded-lg flex items-center justify-center overflow-hidden ${
              appearanceMode === "dark"
                ? "border-[2px] border-verba-blue"
                : "border-[1px] border-border-gray dark:border-border-gray-dk"
            }`}
          >
            <img
              src={DarkModeBg}
              alt="dark-mode"
              className="w-full h-full object-cover"
            />
            {appearanceMode === "dark" && (
              <div className="absolute inset-0 bg-verba-blue/10" />
            )}
            {appearanceMode === "dark" && (
              <div className="absolute bottom-[7px] right-[7px] w-[16px] h-[16px] bg-verba-blue-dark-mode dark:bg-verba-blue-dark-mode-dk rounded-full flex items-center justify-center">
                <CheckIcon className="w-[12px] h-[12px] text-pure-white dark:text-pure-white" />
              </div>
            )}
          </div>
          <p className="text-md font-semibold text-heading-text dark:text-heading-text-dk">
            Dark
          </p>
        </button>

        <button
          className="flex flex-col gap-[8px]"
          onClick={() => handleAppearanceChange("auto")}
        >
          <div
            className={`relative w-[125px] h-[82px] rounded-lg flex items-center justify-center overflow-hidden ${
              appearanceMode === "auto"
                ? "border-[2px] border-verba-blue"
                : "border-[1px] border-border-gray dark:border-border-gray-dk"
            }`}
          >
            <img
              src={AutoModeBg}
              alt="auto-mode"
              className="w-full h-full object-cover"
            />
            {appearanceMode === "auto" && (
              <div className="absolute inset-0 bg-verba-blue/10" />
            )}
            {appearanceMode === "auto" && (
              <div className="absolute bottom-[7px] right-[7px] w-[16px] h-[16px] bg-verba-blue-dark-mode dark:bg-verba-blue-dark-mode-dk rounded-full flex items-center justify-center">
                <CheckIcon className="w-[12px] h-[12px] text-pure-white dark:text-pure-white" />
              </div>
            )}
          </div>
          <p className="text-md font-semibold text-heading-text dark:text-heading-text-dk">
            Auto
          </p>
        </button>
      </div>
    </div>
  );
};

export default Appearance;
